import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

export interface OnOffSwitchProps {
  value: boolean;
  onChange: (newValue: boolean) => void;
  label?: string;
  labelPlacement?: "end" | "start" | "top" | "bottom";
  defaultChecked?: boolean;
  disabled?: boolean | undefined;
}

export const OnOffSwitch = ({
  value,
  onChange,
  label,
  labelPlacement = "end",
  defaultChecked,
  disabled = false
}: OnOffSwitchProps): JSX.Element => {
  return (
    <CustomFormControlLabel
      control={
        <CustomSwitch
          defaultChecked={defaultChecked}
          disableRipple={true}
          checked={value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onChange(event.target.checked)
          }
        />
      }
      label={label}
      labelPlacement={labelPlacement}
      disabled={disabled}
    />
  );
};

const CustomFormControlLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    margin: 0;
    .MuiFormControlLabel-label {
      font-size: 0.75rem;
    }
  }

  display: flex;
  width: 100%;
  flex-grow: 1;
  flex-direction: row-reverse;
  justify-content: space-between;
  gap: 8px;
`;

const CustomSwitch = styled(Switch)`
  &.MuiSwitch-root {
    width: 42px;
    height: 20px;
    padding: 0;

    .MuiSwitch-switchBase {
      color: white !important;
      padding: 4px;

      .MuiSwitch-thumb {
        color: white;
        width: 12px;
        height: 12px;
        margin: 0;
      }

      &.Mui-checked {
        color: #19173f !important;
        transform: translateX(22px) !important;
        & + .MuiSwitch-track {
          &:before {
            opacity: 1;
          }
          &:after {
            opacity: 0;
          }
        }
      }

      &.Mui-disabled {
        cursor: not-allowed !important;
        & + .MuiSwitch-track {
          background-color: rgba(0, 0, 0, 0.2);
        }
      }
    }

    .MuiSwitch-track {
      width: 42px;
      height: 20px;
      border-radius: 20px;
      background-color: ${props =>
        props.checked ? "#19173f;" : "rgba(0, 0, 0, 0.6)"};
      opacity: 1 !important;
      // transition: all 100ms;
      &:before,
      &:after {
        color: white;
        font-size: 10px;
        position: absolute;
        top: 3px;
      }
      &:before {
        content: "ON";
        left: 5px;
        opacity: 0;
        transition: opacity 200ms ease-out;
      }
      &:after {
        content: "OFF";
        right: 5px;
        opacity: 1;
        transition: opacity 200ms ease-out;
      }
    }
  }
`;
